import { Button } from '#app/components/Buttons/Button.js';
import { Grid } from '#app/components/Grid/Grid.js';
import { animated } from '#app/components/Primitives/Animated.js';
import { Text } from '#app/components/Primitives/Text.js';
import { css, styled } from 'styled-components';

const BANNER_COLOR_TRANSITION_MS = 900;

export const GridLayout = styled(Grid)`
  position: relative;
  z-index: 1;
  max-width: 1170px;
  margin: 0 auto;
  padding: 0 16px;
  margin-top: -32px;
  margin-bottom: 144px;

  ${({ theme }) => css`
    ${theme.mediaQueries.md} {
      margin-top: -123px;
    }
  `}
`;

export const HeaderContainer = styled.div`
  ${({ theme }) => css`
    display: block;
    gap: 12px;
    display: flex;
    flex-direction: column;

    ${theme.mediaQueries.md} {
      width: 100%;
      position: relative;
      z-index: 0;
    }
  `}
`;

export const SectionText = styled(Text).attrs({
  textStyle: 'bodyRegular',
})`
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray70};
    display: flex;
    gap: 8px;
    align-items: center;
  `}
`;
export const LogoAndName = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 12px;
    align-items: end;

    ${theme.mediaQueries.md} {
      align-items: center;
      gap: 20px;
    }

    > div:first-child {
      flex-shrink: 0;
    }
  `}
`;

export const CompanyDescription = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 12px;
`;

export const BannerActions = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    width: 100vw;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 12px 16px 24px 16px;
    border-top: 1px solid ${theme.colorsV2.gray30};
    background-color: ${theme.colorsV2.white};
    z-index: ${theme.zIndices.toolbar};
    box-shadow: ${theme.boxShadowV2.basic20};

    ${theme.mediaQueries.md} {
      position: absolute;
      z-index: 1;
      right: 32px;
      top: 16px;
      gap: 8px;

      background: transparent;
      border: none;
      width: auto;
      box-shadow: none;
      justify-content: start;
      left: unset;
      bottom: unset;
    }
  `}
`;

export const ShareButton = styled(Button)``;

export const Column = styled(animated.div)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  transform-origin: top center;
`;
export const Banner = styled.div<{ $companyColor?: string }>`
  ${({ $companyColor = 'transparent', theme }) => css`
    background: ${$companyColor};
    width: 100%;
    position: relative;
    height: 128px;
    transition: background ${BANNER_COLOR_TRANSITION_MS}ms ease;

    ${theme.mediaQueries.md} {
      display: block;
      height: 211px;

      &:after {
        content: '';
        height: 100%;
        width: 100%;
        background: linear-gradient(to bottom, transparent 0%, #000000 225%);
        position: absolute;
        inset: 0;
      }
    }

    @media (min-width: 1525px) {
      border-radius: 16px;
      &:after {
        border-radius: 16px;
      }
    }
  `}
`;
